/**
 * 功能: 目录组件, 显示章节目录、图表目录、名词解释和报告日志
 */
<template lang="pug">
  div.slide-header
    .left
      a(href="/" class='goBack')
        img.line(src="@/images/logo.svg")
      p.left-brief-name {{brief.title}}
      el-tag.tag(v-for="(tag,index) in brief.industry" :key="index") {{tag}}
    .right
      label(v-popover:popover)
        p(class="fa fa-bars outline") 目录
      el-popover(placement="right" trigger="hover" width="400" :visible-arrow="false" ref="popover")
        Aside(:glossaryArr="glossaryArr" :chartOutline="chartOutline" :outlineWbs="outlineWbs" :updateLog="updateLog")
</template>

<script>
import Aside from './aside'
export default {
  name: 'Header',
  components: {
    Aside
  },
  props: {
    glossaryArr: { type: Array, default: () => [] },
    chartOutline: { type: Array, default: () => [] },
    outlineWbs: { type: Array, default: () => [] },
    brief: { type: Object, default: () => {} },
    updateLog: { type: Array, default: () => {} }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>
.goBack{
  display: flex;
}
.slide-header{
  width: 1200px;
  display: flex;
  align-items: center;
  position: relative;
}
.left{
  display:flex;
  align-items: center;
  width: 900px;
}
.right{
  position: absolute;
  right: 0;
}
.left-brief-name{
  font-size: 1.5rem;
}
.line{
  border-right: 1px solid #D9D9D9;;
  margin-right: -1px;
  padding-right: 25px;
  margin:0 25px 0 0;
  height:30px;
}
.line:hover{
  cursor:pointer;
}
.tag{
  margin-left: 10px;
}
</style>
